<script setup lang="ts">
/**
 * UI-kit component
 * Category: Headers
 * Name: HeaderMenu
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=4214-21191
 *
 * The expanded header panel. Desktop (1200+, header-specific breakpoint): a full-width dropdown under the
 * bar — glass fill, 1px border, bottom corners radius/32, content blocks in a
 * wrapping row with the banner (#banner) on the right. Below desktop: a
 * full-screen sheet — no border/radius, the content area scrolls and the #cta
 * strip is pinned to the foot. The banner renders on desktop only; the CTA
 * strip on tablet/mobile only. Overflow inside the sheet is a scroll, not a
 * layout bug. effects/glass-light is missing from the installed LumeeUI tokens
 * (dsGap) — the glass treatment falls back to rgba white + blur(8px).
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui.
 */
// types
import type { HeaderMenuProps } from '../types/interfaces'

defineOptions({
  name: 'HeaderMenu',
})

withDefaults(defineProps<HeaderMenuProps>(), {
  showBanner: true,
})
</script>

<template>
  <div class="header-menu">
    <div class="header-menu__content">
      <slot />
    </div>
    <div
      v-if="showBanner && $slots.banner"
      class="header-menu__banner"
    >
      <slot name="banner" />
    </div>
    <div
      v-if="$slots.cta"
      class="header-menu__cta"
    >
      <slot name="cta" />
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_header-menu.scss" />
